'use client';
import { atom } from 'jotai';

export const countryRegistrationStepAtom = atom<{
	countryPrivacyPolicy?: string;
	countryTermsAndConditions?: string;
	isPolicyLoading: boolean;
	isUserCountriesQueryLoading: boolean;
	ncwTermsAndConditions?: string;
}>({
	isPolicyLoading: false,
	isUserCountriesQueryLoading: false
});
